import styles from './CopyPayLink.module.css';
import { PayLinks } from '../../../../api/lending/edge';
import { CopyButton } from '../../../../components/CopyButton/CopyButton';
import { copy } from '../../../../components/util/copy';
import { getPayLinkUrlPath } from '../../../../utils/getPayLinkUrl';
import { getUrlFromPath } from '../../../../utils/getUrlFromPath';

const buildUrlTarget = (paylink: PayLinks[0]): string => {
  if (paylink.order) {
    return getUrlFromPath(`/pay/order/${paylink.order.order_id}/landing/`)!;
  }

  return getUrlFromPath(getPayLinkUrlPath(paylink.seller_name, paylink.id))!;
};

export const CopyPayLink = ({ payLink }: { payLink: PayLinks[0] }) => {
  const url = buildUrlTarget(payLink);

  return (
    <CopyButton className={styles.copyLink} onClick={() => copy(url)}>
      <span className={styles.copyLinkText}>Copy link</span>
    </CopyButton>
  );
};
